import { convertToStringPercentage } from 'utils/stringFormattingHelpers';

/**
 * Takes the max and min of a mortality range and converts it to a string. If the values are the same
 * it will display the value, otherwise it will display the range.
 * NOTE: All values below 1% are converted to <1%
 *
 * @param max The max number of the range
 * @param min The min number of the range
 */
export const mortalityRateToRangeString = (max: number, min: number) => {
  if (max != null || min != null) {
    if (min == null) return convertToStringPercentage(max, 2);
    if (max == null) return convertToStringPercentage(min, 2);

    const maxStringPercentage = convertToStringPercentage(max, 2);
    const minStringPercentage = convertToStringPercentage(min, 2);

    if (maxStringPercentage === minStringPercentage || (min < 0.01 && max < 0.01)) {
      return maxStringPercentage;
    }

    return `${
      min < 0.01 ? (min === 0 ? '0' : '<1%') : +(min * 100).toFixed(2)
    } - ${convertToStringPercentage(max, 2)}`;
  }
  return null;
};
